import { UserIcon } from "../../assets/icons";
import { User } from "../management/ManageAccounts";
import { useOutletContext } from "react-router-dom";

const UserProfile = () => {
    const user: User = useOutletContext();

    console.log(user)
    return (
        <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-neutral-800 dark:text-white mb-4">Account</h2>
            <div className="flex items-center space-x-4">
                <UserIcon />
                <div>
                    <p className="text-lg font-medium text-neutral-900 dark:text-white">{user.name}</p>
                    <p className="text-sm text-neutral-500 dark:text-neutral-400">{user.email}</p>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
